export default __webpack_public_path__ + "locales/it/FilesSettings.json?hash=0b0a692467e17f3ad25dad14bc3cc0f0";